<template>
  <div>
    <tripwiseHeader :type='2'></tripwiseHeader>
    <div class="banner">
      <img class="bannerBg" src="https://image.ceekee.com/pc/secondwebsite/product/qita_bg.png" />
      <div class="content b-flex b-flex-column b-align-centenr b-justify-end">
        <img src="https://image.ceekee.com/pc/secondwebsite/product/title_center.png" class="title" />
        <div class="intro">
          <img
            class="img"
            src="https://image.ceekee.com/pc/secondwebsite/product/center_image01.png"
          />
          <div class="button b-flex b-flex-column b-align-centenr b-justify-center" @click="toGet">立即获取</div>
        </div>
      </div>
    </div>
    <div class="scene b-flex b-flex-column b-align-centenr">
      <div class="title">覆盖企业差旅全场景，赋能企业费用管控全闭环</div>
      <div>
        <div class="scene-margin b-flex b-flex-row">
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:72px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_plane.png"
            />
            <span class="scene-title">机票</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:23px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_jiudian.png"
            />
            <span class="scene-title">酒店</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:40px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_huoche.png"
            />
            <span class="scene-title">火车</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:50px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_yongche.png"
            />
            <span class="scene-title">用车</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:46px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_huiyi.png"
            />
            <span class="scene-title">会议</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center scene-item-shadow"
          >
            <img
              style="width:38px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_canyin.png"
            />
            <span class="scene-title">餐饮</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:38px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_youfei.png"
            />
            <span class="scene-title">油费</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:30px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_guolufei.png"
            />
            <span class="scene-title">过路费</span>
          </div>
          <div class="scene-item b-flex b-flex-column b-align-centenr b-justify-center">
            <img
              style="width:40px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_kuaidi.png"
            />
            <span class="scene-title">快递</span>
          </div>
        </div>
        <div class="scene-margin b-flex b-flex-row">
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:58px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_daba.png"
            />
            <span class="scene-title">大巴</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:40px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_waimai.png"
            />
            <span class="scene-title">外卖</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center scene-item-shadow"
          >
            <img
              style="width:40px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_caigou.png"
            />
            <span class="scene-title">采购</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:36px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_ditie.png"
            />
            <span class="scene-title">地铁</span>
          </div>
          <div class="scene-item b-flex b-flex-column b-align-centenr b-justify-center">
            <img
              style="width:40px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_gongjiao.png"
            />
            <span class="scene-title">公交</span>
          </div>
        </div>
        <div class="b-flex b-flex-row">
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:40px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_zuzhi.png"
            />
            <span class="scene-title">组织</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center scene-item-shadow"
          >
            <img
              style="width:30px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_chaibiao.png"
            />
            <span class="scene-title">差标</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:37px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_shenpi.png"
            />
            <span class="scene-title">审批</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:42px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_yusuan.png"
            />
            <span class="scene-title">预算</span>
          </div>
          <div class="scene-item b-flex b-flex-column b-align-centenr b-justify-center">
            <img
              style="width:37px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_danju.png"
            />
            <span class="scene-title">单据</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:40px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_hexiao.png"
            />
            <span class="scene-title">核销</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center"
          >
            <img
              style="width:38px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_feiyong.png"
            />
            <span class="scene-title">费用</span>
          </div>
          <div
            class="scene-item-margin scene-item b-flex b-flex-column b-align-centenr b-justify-center scene-item-shadow"
          >
            <img
              style="width:50px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_shuju.png"
            />
            <span class="scene-title">数据</span>
          </div>
          <div class="scene-item b-flex b-flex-column b-align-centenr b-justify-center">
            <img
              style="width:44px;height:40px;"
              src="https://image.ceekee.com/pc/secondwebsite/product/center_caiwu.png"
            />
            <span class="scene-title">财务</span>
          </div>
        </div>
      </div>
    </div>
    <div class="saas backgroud b-flex b-flex-column b-align-centenr">
        <div class="title">多种SaaS产品选择</div>
        <img class="img" src="https://image.ceekee.com/pc/secondwebsite/product/center_image03.png" />
    </div>
    <div class="service b-flex b-flex-row b-align-centenr b-justify-end">
      <div class="service-content">
        <div class="service-title">完善的服务体系</div>
        <div class="intro">帮助企业大幅度提升管理效率</div>
        <div class="detail b-flex b-flex-row">
          <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/product/icon_sel_16.png" />
          审批流配置 定制符合客户方差旅政策和企业规范需求的预订流程
        </div>
        <div class="detail b-flex b-flex-row">
          <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/product/icon_sel_16.png" />
          差旅政策配置 部门、员工、航司等多条件差旅行为管理，协助企业梳理差旅政策
        </div>
        <div class="detail b-flex b-flex-row">
          <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/product/icon_sel_16.png" />
          高管VIP服务定制 VIP人员差旅全程贴心服务，提供管家式差旅咨询
        </div>
        <div class="detail b-flex b-flex-row">
          <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/product/icon_sel_16.png" />
          专属客服定制 配备专人客服24小时在线微信交流，直达第一线
        </div>
        <div class="detail b-flex b-flex-row">
          <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/product/icon_sel_16.png" />
          差旅报告定制 提供每日比价报告，提供差旅采购分析报告，针对性提出差旅改进建议
        </div>
      </div>
      <img class="img1" src="https://image.ceekee.com/pc/secondwebsite/product/center_image04.png" />
    </div>
    <div class="service value backgroud b-flex b-flex-row b-align-centenr b-justify-end">
      <div class="service-content">
        <div class="service-title">产品价值</div>
        <div class="intro">帮助企业节省差旅成本，创造更大价值</div>
        <div class="detail b-flex b-flex-row">
          <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/product/icon_sel_16.png" />
          <span>
          节省开支
          <span>25%</span>：企业差旅事前—事中—事后全流程管控，超过
          <span>25%</span> 的差旅成本</span>
        </div>
        <div class="detail b-flex b-flex-row">
          <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/product/icon_sel_16.png" />
          <span>提升效率
          <span>95%</span>：财务统一结算 企业统一支付 降低超过
          <span>95%</span> 的发票处理</span>
        </div>
        <div class="detail b-flex b-flex-row">
          <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/product/icon_sel_16.png" />
          <span>员工体验
          <span>100%</span>：免贴票免报销免垫资 报销更智能、更便捷</span>
        </div>
        <div class="detail b-flex b-flex-row">
          <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/product/icon_sel_16.png" />
          <span>数据分析
          <span>100%</span>：实时多维度数据报告，帮助企业提升管理效率</span>
        </div>
      </div>
      <img class="img2" src="https://image.ceekee.com/pc/secondwebsite/product/center_value.png" />
    </div>
    <tripwiseBottom></tripwiseBottom>
  </div>
</template>

<script>
import tripwiseHeader from "@/components/header";
import tripwiseBottom from "@/components/bottom";
export default {
  components: {
    tripwiseHeader,
    tripwiseBottom
  },
  methods:{
    toGet(){
      this.$router.push("/apply");
    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  overflow: hidden;
  position: relative;
  .bannerBg {
    width: 100%;
  }
  .content {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .title {
      width: 22.9%;
    }
    .intro {
      width: 64.2%;
      position: relative;
      .img {
        width: 100%;
      }
      .button {
        position: absolute;
        z-index: 2;
        top: 40px;
        left: 43.18%;
        width: 168px;
        height: 47px;
        background: #ffffff;
        border-radius: 4px;
        font-size: 16px;
        color: #0376f7;
        line-height: 16px;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
}
.backgroud {
  background: #f7fbfe;
}
.scene {
  background: #fff;
  padding: 219px 0 164px;
  .title {
    font-size: 40px;
    color: #000000;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 80px;
  }
  .scene-margin {
    margin-bottom: 58px;
  }
  .scene-item {
    width: 120px;
    height: 120px;
    background: #ffffff;
    box-shadow: 0px 0px 61px 0px rgba(187, 216, 250, 0.2);
    border-radius: 60px;
    .scene-title {
      margin-top: 12px;
      font-size: 20px;
      color: #000000;
      line-height: 20px;
      font-weight: 400;
    }
  }
  .scene-item-shadow {
    box-shadow: 0px 32px 84px 0px rgba(14, 86, 124, 0.16);
  }
  .scene-item-margin {
    margin-right: 40px;
  }

   @media screen and (max-width: 1400px) {
     .scene-item {
    width: 100px;
    height: 100px;
    background: #ffffff;
    box-shadow: 0px 0px 61px 0px rgba(187, 216, 250, 0.2);
    border-radius: 50px;
    .scene-title {
      margin-top: 12px;
      font-size: 18px;
      color: #000000;
      line-height: 18px;
      font-weight: 400;
    }
  }
  .scene-item-shadow {
    box-shadow: 0px 32px 84px 0px rgba(14, 86, 124, 0.16);
  }
  .scene-item-margin {
    margin-right: 30px;
  }
   }
}
.value {
  padding: 300px 0 268px;
}
.service {
  padding: 170px 0;
  .img1 {
    width: 41.7%;
    margin-left: 5.8%;
  }
  .img2 {
    margin-right: 8.5%;
    width: 39.2%;
    margin-left: 0.14%;
  }
  .service-content{
    padding: 0 20px;
  }
  .service-title {
    font-size: 40px;
    color: #111111;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 60px;
  }
  .intro {
    font-size: 18px;
    color: #666666;
    line-height: 18px;
    font-weight: 600;
    margin-bottom: 80px;
  }
  .detail {
    font-size: 16px;
    color: #666666;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 30px;
    .icon {
      height: 16px;
      width: 16px;
      margin-right: 22px;
    }
    .discount {
      font-size: 20px;
      color: #0376f7;
      line-height: 20px;
      font-weight: 600;
    }
  }
}
.saas {
  padding: 135px 0 57px;
  .title {
    font-size: 40px;
    color: #1d293f;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 18px;
  }
  .img {
    width: 66.3%;
  }
}
</style>